import { makeStyles } from '@material-ui/core';

export default makeStyles(() => {
  return {
    root: {
      display: 'none',
      margin: '3mm 6mm !important',
      '@media print': {
        display: 'block',
        '-webkit-print-color-adjust': 'exact !important' /* Chrome, Safari */,
        'color-adjust': 'exact !important',
      },
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    blackLine: {
      backgroundColor: 'black !important',
      textAlign: 'center',
      color: 'white',
      borderTop: '1px solid white',
    },
    logo: {
      backgroundColor: 'white',
      textAlign: 'left',
    },
    infoBox: {
      width: '100%',
      display: 'grid',
    },
    containerProducts: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    containerTopping: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      paddingLeft: '20px',
    },
    containerComments: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    containerMarketPlace: {
      borderTop: '1px solid grey',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    containerTotal: {
      borderTop: '1px solid black',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      backgroundColor: 'black !important',
      color: 'white',
    },
    fontText: {
      fontSize: '10px',
      fontFamily: 'Poppins',
    },
    pagebreak: {
      '@media print': {
        BreakBefore: 'always',
        pageBreakBefore: 'always',
        display: 'block',
        whiteSpace: 'nowrap',
      },
    },
    left: {
      float: 'left',
      color: 'black',
    },
    right: {
      float: 'right',
      color: 'black',
    },
  };
});
